import React from 'react';
import styled from 'styled-components';

const ContractFarmingProject = () => {
  const data = [
    // No. 1 - Combining both BOHOL - CEBU-SEQUIJOR IMO (CEBU OFFICE) and BOHOL - CEBU-SEQUIJOR IMO (BOHOL OFFICE)
    {
      office: 'BOHOL - CEBU-SEQUIJOR IMO (CEBU OFFICE) / BOHOL - CEBU-SEQUIJOR IMO (BOHOL OFFICE)',
      system: 'CAN ASUJAN SRIS / ILAYA SRIS',
      ia: 'INTEGRATED CARCAR RICE IRRIGATORS ASSOCIATION, INC. / UBAY MALINGIN IA',
      location: 'BOLINAWAN, CARCAR, CEBU / SAN FRANCISCO, UBAY, BOHOL',
      farmerCount: '68 / 50',
      ffrsNo: 'Wet 2024',
      area: '68 / 50',
      machinery: 'Transplanter, Harvester, Rice Mill / Rice Mill, Elf',
      machineryStatus: 'NOT YET STARTED',
      remarks: 'On going negotiation of IAs / On going validation at the field',
    },
    // No. 2 - BOHOL INTEGRATED IRRIGATION SYSTEM
    {
      office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
      system: 'BAYONGAN IS / MALINAO IS',
      ia: 'TOBUCALM IRRIGATORS ASSOCIATION / CARLIM IRRIGATORS ASSOCIATION',
      location: 'CAMALI-AN, UBAY, BOHOL / CAGAWASAN, PILAR, BOHOL',
      farmerCount: '150 / 100',
      ffrsNo: 'Wet 2024',
      area: '150 / 100',
      machinery: 'Rice Mill, Elf, Mechanical Dryer / Rice Mill, Elf, Mechanical Dryer, 4WD Tractor',
      machineryStatus: 'NOT YET STARTED',
      remarks: 'Conducted SMC Meeting for the presentation of the Project for the approval of the IAs/FIA / Scheduled SMC Meeting on March 1, 2024',
    },
    // Additional IAs for BAYONGAN IS - TOBUCALM IRRIGATORS ASSOCIATION and BAYONGAN ENDPOINT UNITED IRRIGATORS ASSOCIATION
    {
      office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
      system: 'BAYONGAN IS',
      ia: 'BAYONGAN ENDPOINT UNITED IRRIGATORS ASSOCIATION',
      location: 'CAMALI-AN, UBAY, BOHOL',
      farmerCount: '50',
      ffrsNo: 'Wet 2024',
      area: '50',
      machinery: 'Rice Mill, Elf, Mechanical Dryer, 4WD Tractor',
      machineryStatus: 'NOT YET STARTED',
      remarks: 'Conducted SMC Meeting for the presentation of the Project for the approval of the IAs/FIA',
    },
    // Additional system - MALINAO IS
    {
      office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
      system: 'MALINAO IS',
      ia: 'CARLIM IRRIGATORS ASSOCIATION',
      location: 'CAGAWASAN, PILAR, BOHOL',
      farmerCount: '100',
      ffrsNo: 'Wet 2024',
      area: '100',
      machinery: 'Rice Mill, Elf, Mechanical Dryer, 4WD Tractor',
      machineryStatus: 'NOT YET STARTED',
      remarks: 'Scheduled SMC Meeting on March 1, 2024',
    },

    {
        office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
        system: 'CAPAYAS',
        ia: 'TRIPLE C & T',
        location: 'TUBORAN, UBAY, BOHOL',
        farmerCount: '25',
        ffrsNo: 'Wet 2024',
        machinery: 'Rice Mill, Elf, Mechanical Dryer, 4WD Tractor',
        machineryStatus: 'NOT YET STARTED',
        remarks: 'Conducted SMC Meeting for the presentation of the Project for the approval of the Ias/FIA',
      },

      
      {
        office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
        system: 'TALIBON',
        ia: 'PANABANG IA ',
        location: 'SAN JOSE, TALIBON, BOHOLL',
        farmerCount: '50',
        ffrsNo: 'Wet 2024',
        machinery : '4WD Tractor, Harvester, Mechanical Dryer , Transplanter, Rice Mill',
        machineryStatus: 'NOT YET STARTED',
        remarks: 'On going negotiation with the IAs',
      },

      {
        office: 'BOHOL INTEGRATED IRRIGATION SYSTEM',
        system: 'BENLIW',
        ia: 'BEBICAS IA  ',
        location: 'BENLIW, UBAY, BOHOL',
        farmerCount: '25',
        ffrsNo: 'Wet 2024',
        machinery : 'Mechanical Dryer, Harvester ',
        machineryStatus: 'NOT YET STARTED',
        remarks: 'On going negotiation with the IAs',
      },
  ];

  return (
    <Container>
      <Title>Farming Project - Region 7</Title>
      <Table>
        <thead>
          <tr>
            <TableHeader>NO.</TableHeader>
            <TableHeader>NAME OF OFFICE/IMO</TableHeader>
            <TableHeader>NAME OF SYSTEM</TableHeader>
            <TableHeader>NAME OF IA</TableHeader>
            <TableHeader>LOCATION</TableHeader>
            <TableHeader>No. of Farmers</TableHeader>
            <TableHeader>FFRS No.</TableHeader>
            <TableHeader>AREA (Has.)</TableHeader>
            <TableHeader>Target of Implementation</TableHeader>
            <TableHeader>Farm Machinery Status</TableHeader>
            <TableHeader>Remarks</TableHeader>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <TableData>{index + 1}</TableData>
              <TableData>{item.office}</TableData>
              <TableData>{item.system}</TableData>
              <TableData>{item.ia}</TableData>
              <TableData>{item.location}</TableData>
              <TableData>{item.farmerCount}</TableData>
              <TableData>{item.ffrsNo}</TableData>
              <TableData>{item.area}</TableData>
              <TableData>{item.machinery}</TableData>
              <TableData>{item.machineryStatus}</TableData>
              <TableData>{item.remarks}</TableData>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default ContractFarmingProject;

// Styled Components
const Container = styled.div`
  font-family: 'Arial', sans-serif;
  background-color: #f5f5f5;
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: rgb(29, 87, 55);
  text-align: center;
  margin-bottom: 30px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const TableHeader = styled.th`
  background-color:rgb(29, 87, 37);
  color: white;
  padding: 10px;
  font-size: 14px;
  text-align: left;
`;

const TableData = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 14px;
  text-align: left;
`;

